// extracted by mini-css-extract-plugin
module.exports = {"text":"FlashBanner_text_q3DA-","close":"FlashBanner_close_1dSJ0"};